export function toUnderscore(target: string): string {
  return target
    .replace(' ', '_')
    .replace(/(?:^|\.?)([A-Z])/g, (x, y) => '_' + y.toLowerCase())
    .replace(/^_/, '')
    .toUpperCase()
}

export function toDash(target: string): string {
  return target
    .replace(/(?:^|\.?)([A-Z])/g, (x, y) => '-' + y.toLowerCase())
    .replace(/^_/, '')
}


export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}


export class TextWidth {
  private readonly canvas: HTMLCanvasElement = document.createElement('canvas')
  private readonly context: CanvasRenderingContext2D = this.canvas.getContext('2d')

  public setFont(font): void {
    this.context.font = font
  }

  public get(text): number {
    return this.context.measureText(text).width
  }
}


export function replaceAll(target: string, subStr: string, newSubStr: string): string {
  return target.replace(new RegExp(subStr, 'g'), newSubStr)
}


export function injectString(str: string, inject: string, index: number): string {
  let newStr = ''
  for (let i = 0; i < str.length; i++) {
    newStr += str[i]
    if (i === 0 || i % index !== 0) continue
    newStr += inject
  }

  return newStr
}
